import React, { useState } from 'react';
import './CollapsibleGrid.css';

function CollapsibleGrid({
    data,
    columns,
    columnstranslate,
    onView,
    onEdit,
    onDelete,
    renderExpandedContent, // Function to render collapsible content
    expandMode = 'single', // 'single' or 'multiple'
    uniquieid = 'id'
}) {
    const [expandedRows, setExpandedRows] = useState(new Set());

    const toggleRow = (rowId) => {
        setExpandedRows((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(rowId)) {
                newSet.delete(rowId);
            } else {
                if (expandMode === 'single') {
                    newSet.clear();
                }
                newSet.add(rowId);
            }
            return newSet;
        });
    };

    const createIcon = (name) => {
        const icons = {
            'chevron-down': '<polyline points="6,9 12,15 18,9"></polyline>',
            'chevron-right': '<polyline points="9,18 15,12 9,6"></polyline>',
            'eye': '<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle>',
            'edit': '<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="m18.5 2.5-3 3L22 12l-3 3-3-3-6.5 6.5"></path>',
            'trash': '<polyline points="3,6 5,6 21,6"></polyline><path d="m19,6v14a2 2 0 0 1-2,2H7a2 2 0 0 1-2-2V6m3,0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2,2v2"></path>',
            'clock': '<circle cx="12" cy="12" r="10"></circle><polyline points="12,6 12,12 16,14"></polyline>',
            'users': '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="m23 21v-2a4 4 0 0 0-3-3.87"></path><path d="m16 3.13a4 4 0 0 1 0 7.75"></path>',
            'dollar-sign': '<line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>'
        };
        return `<svg class="icon" viewBox="0 0 24 24">${icons[name] || ''}</svg>`;
    };

    return (
        <div className="collapsible-grid">
            <table className="grid-table">
                <thead>
                    <tr className="grid-th">
                        {columns.map((col, index) => (
                            <th key={index}>{columnstranslate[index]}</th>
                        ))}
                        {/* Handling buttons column */}
                        <th>Detaljer / Handling</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row) => {
                        const isExpanded = expandedRows.has(row[uniquieid]);
                        return (
                            <React.Fragment key={row[uniquieid]}>
                                {/* Main row */}
                                <tr
                                    className={`grid-main-row ${isExpanded ? 'expanded-hover' : ''}`}
                                >
                                    {columns.map((col, idx) => (
                                        <td key={idx}
                                            className={`grid-td justify-center ${idx==0 ? 'hover-mouse' : ''}`}
                                            onClick={() => {
                                            if (idx === 0) {
                                                toggleRow(row[uniquieid]);
                                            }
                                        }}>

                                        <div class="dflex">
                                                {row[col] != null ? <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: row[col],
                                                    }}
                                                /> : 'N/A'}
                                            {idx === 0 && (
                                                <button
                                                   
                                                        className="expand-btn border-0 bg-transparent"
                                                >
                                                    <span
                                                        dangerouslySetInnerHTML={{
                                                            __html: createIcon(isExpanded ? 'chevron-down' : 'chevron-right'),
                                                        }}
                                                    />
                                                </button>
                                                )}
                                            </div>
                                        </td>
                                    ))}
                                    {/* Action buttons */}
                                    <td className="grid-td actions-cell">
                                        <div class="actions-container justify-center ">
                                            <button class="icon-button view-button" onClick={() => onView(row)}>
                                                <span
                                                dangerouslySetInnerHTML={{
                                                    __html: createIcon('eye'),
                                                }}
                                                />
                                                VIS</button>
                                            <button class="icon-button edit-button" onClick={() => onEdit(row)}>
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: createIcon('edit'),
                                                    }}
                                                />
                                                REDIGERE</button>
                                            <button class="icon-button delete-button" onClick={() => onDelete(row)}>
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: createIcon('trash'),
                                                    }}
                                                />
                                                AVBESTILL</button>
                                        </div>
                                    </td>
                                </tr>
                                {/* Collapsible content row */}
                                {isExpanded && renderExpandedContent && (
                                    <tr className={`grid-expanded-row grid-container ${isExpanded ? 'expand' : 'collapse'}`}>
                                        <td colSpan={columns.length + 1} className="expanded-cell">
                                            {renderExpandedContent(row)}
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default CollapsibleGrid;